export const RELATED_OBJECTS_COLUMN_ID = "relatedObjects"

export const TASK_TABLE_HEADERS = [
    { id: "title", name: "Title", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: false, canReorder: false } },
    { id: "updates", name: "Updates", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: false, canReorder: false } },
    { id: "status", name: "Status", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "dueDate", name: "Due Date", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assignedTo", name: "Assigned To", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "group", name: "Group", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "board", name: "Board", sortable: false, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "dateAdded", name: "Creation Log", sortable: true, preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]

// Only the My Tasks view gets this column. Board views already render each FK
// custom column individually, so an aggregate there would just duplicate them.
const RELATED_OBJECTS_HEADER = {
    id: RELATED_OBJECTS_COLUMN_ID,
    name: "Related Objects",
    sortable: false,
    preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true },
}

export const getDefaultTaskColumnConfig = ({ includeRelatedObjects = false } = {}) => {
    const headers = includeRelatedObjects
        ? TASK_TABLE_HEADERS.flatMap((column) =>
            column.id === "board" ? [column, RELATED_OBJECTS_HEADER] : [column]
        )
        : TASK_TABLE_HEADERS

    return headers.map((column, index) => ({ ...column, order: index }))
}

export const isRelatedObjectsColumnVisible = (columnConfig) =>
    (columnConfig || []).some(
        (column) => column?.id === RELATED_OBJECTS_COLUMN_ID && column?.preferenceSettings?.isVisible
    )

// Column ids TaskList has a <td> branch for. It renders a <th> per visible column
// but a <td> only from an id-matched branch, so an id in one list and not the other
// shifts every later cell one column left. TaskList renders an empty placeholder
// cell for anything this returns false for.
//
// Reachable through buildColumnConfigFromPreference, which turns an unrecognised id
// in a saved preference into a synthetic column: "creationLog" was renamed to
// "dateAdded" in f032dc481, and preferences saved before that still carry the old id.
const CELL_RENDERER_IDS = new Set([
    "title", "updates", "status", "dueDate", "assignedTo", "group", "board", "dateAdded",
    RELATED_OBJECTS_COLUMN_ID,
])

export const hasCellRenderer = (headerId = "") =>
    CELL_RENDERER_IDS.has(headerId) || String(headerId).startsWith("custom_column_")
